import React from 'react';
import Text from './Text';

export default function ErrorText({ error }) {
  return (
    <Text color='red' size={13}>{error}</Text>
  );
}